import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Input, Modal, Space } from 'antd';
import IntlMessages from '@src/util/IntlMessages';
import useSignatureInput from './hooks/useSignatureInput';
import type { SignatureInputProps } from './hooks/useSignatureInput';
import styles from './styles.module.less';

export default function SignatureInput(props: SignatureInputProps) {
  const intl = useIntl();
  const signature = useSignatureInput(props);
  return (
    <Space direction="vertical" className="gx-w-100">
      {signature.preview && props.value?.url && (
        <img className={styles.preview} src={signature.preview} alt="" />
      )}
      <Button
        onClick={() => {
          signature.clear();
          signature.setOpen(true);
        }}
      >
        <IntlMessages id="signature.capture" />
      </Button>
      {props.includeClarification && (
        <Input
          aria-label={intl.formatMessage({ id: 'eventTypes.component.clarification' })}
          placeholder={intl.formatMessage({ id: 'eventTypes.component.clarification' })}
          value={props.value?.clarificationValue ?? ''}
          onChange={event =>
            props.onChange?.({
              url: props.value?.url ?? '',
              clarificationValue: event.target.value,
            })
          }
        />
      )}
      <Modal
        open={signature.open}
        title={<IntlMessages id="signature.capture" />}
        destroyOnClose
        closable={!signature.saving}
        maskClosable={!signature.saving}
        onCancel={() => {
          if (!signature.saving) signature.setOpen(false);
        }}
        footer={
          <Space>
            <Button disabled={signature.saving} onClick={signature.clear}>
              <IntlMessages id="signature.clear" />
            </Button>
            <Button
              type="primary"
              disabled={!signature.hasInk}
              loading={signature.saving}
              onClick={signature.sign}
            >
              <IntlMessages id="signature.sign" />
            </Button>
          </Space>
        }
      >
        <canvas
          aria-label={intl.formatMessage({ id: 'signature.capture' })}
          ref={signature.canvas}
          width={600}
          height={240}
          className={styles.canvas}
          onPointerDown={event => signature.draw(event, true)}
          onPointerMove={event => signature.draw(event)}
          onPointerUp={signature.stop}
          onPointerCancel={signature.stop}
        />
      </Modal>
    </Space>
  );
}
